import {mapActions, mapGetters, mapMutations} from "vuex";
import {directive, Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import Moment from 'moment';
import {extendMoment} from 'moment-range';
import {debounce} from 'lodash'

const moment = extendMoment(Moment);

export default {
    name: 'event-datepicker',
    components: {
        Swiper,
        SwiperSlide
    },
    directives: {
        swiper: directive
    },
    data() {
        return {
            swiperOptionsDays: {
                centeredSlides: true,
                slidesPerView: 21,
                preventClicks: false,
                preventClicksPropagation: false,
                breakpoints: {
                    300: {
                        slidesPerView: 5,
                    },
                    420: {
                        slidesPerView: 5,
                    },
                    600: {
                        slidesPerView: 11,
                    },
                    850: {
                        slidesPerView: 17,
                    },
                    1100: {
                        slidesPerView: 21,
                    }
                }
            },
            swiperOptionsMounth: {
                centeredSlides: true,
                slidesPerView: 13,
                // slidesPerView: 'auto',
                preventClicks: false,
                preventClicksPropagation: false,
                breakpoints: {
                    300: {
                        slidesPerView: 3,
                    },
                    420: {
                        slidesPerView: 3,
                    },
                    600: {
                        slidesPerView: 7,
                    },
                    850: {
                        slidesPerView: 9,
                    },
                    1100: {
                        slidesPerView: 13,
                    }
                }
            },
            pickerDays: [],
            pickerMount: [],
            dateCount: {
                from: moment().subtract(14, 'days').format('YYYY-MM-DD'),
                to: moment().add(14, 'days').format('YYYY-MM-DD')
            }
        }
    },
    computed: {
        ...mapGetters({
            listCount: 'events/listCount',
        }),
        swiper() {
            return this.$refs.mySwiper.$swiper
        },
        swiperMount() {
            return this.$refs.swiperMount.$swiper
        },
    },
    mounted() {
        this.init()
    },
    methods: {
        ...mapActions({
            fetchEducationMaterials: 'events/GET_LIST',
            fetchEducationCount: 'events/GET_LIST_COUNT',
        }),
        ...mapMutations({
            changeDate: 'events/CHANGE_DATE'
        }),
        getData() {
            this.fetchEducationMaterials();
            this.fetchEducationCount(this.dateCount).then(() => {
                this.pickerDays = this.pickerDays.map(e => {
                    e.counts = 0
                    e.opacity = 0
                    this.listCount.forEach(t => {
                        if (e.fullDate === t.date) {
                            e.counts = t.count
                            e.opacity = (t.count <= 5 ? t.count / 10 : 0.5) + 0.2
                        }
                    })
                    return e
                })
            })
        },
        changeSliderDay: debounce(function ({activeIndex}) {
            this.setActiveMount(this.pickerDays[activeIndex].fullDate);
            this.addDaysFromEndSlider(activeIndex);

            this.handleClickSliderDay(activeIndex)
        }, 200),
        setCountDated(index) {
            const currentDate = this.pickerDays[index].fullDate

            const endDate = moment(currentDate).add(14, 'days').format('YYYY-MM-DD');
            const startDate = moment(currentDate).subtract(14, 'days').format('YYYY-MM-DD');

            this.dateCount.from = startDate
            this.dateCount.to = endDate
        },
        handleClickSliderDay(index) {
            this.setCountDated(index)
            const lengthSlider = this.pickerDays.length - 1;
            if ((lengthSlider - (lengthSlider - index)) > 15) {
                this.swiper.slideTo(index);
            } else {
                this.addDaysFromEndSlider(index)
            }
        },
        handleClickSliderMount(index) {
            this.addMounthFromEndSlider(index);
            const lengthSlider = this.pickerMount.length - 1;
            if ((lengthSlider - (lengthSlider - index)) > 7) {
                this.swiperMount.slideTo(index);
            }

            this.getDefaultDays(this.pickerMount[index].fullDate);
            this.setActiveDay(this.pickerMount[index].fullDate);
        },
        init() {
            this.getDefaultDays();
            this.setActiveDay();

            this.getDefaultMounts();
            this.setActiveMount();

            this.changeDate({
                from: moment().format('YYYY-MM-DD'),
                to: moment().format('YYYY-MM-DD'),
                // from: '2020-07-17',
                // to: '2020-07-17',
            });

        },
        getDefaultDays(date = null) {
            if (!date) {
                const currentDate = moment();
                const startDate = moment(currentDate).subtract(1, 'months').format('YYYY-MM-DD');
                const endDate = moment(currentDate).add(1, 'months').format('YYYY-MM-DD');
                this.pickerDays = this.getRangeDates(startDate, endDate);
            } else {
                const currentDate = moment(date);
                const startDate = moment(currentDate).subtract(1, 'months').format('YYYY-MM-DD');
                const endDate = moment(currentDate).add(1, 'months').format('YYYY-MM-DD');
                this.pickerDays = this.getRangeDates(startDate, endDate);
            }

        },
        setActiveDay(date = null) {
            if (!date) {
                const currentDate = moment().format('YYYY-MM-DD');
                const index = this.pickerDays.findIndex(e => e.fullDate === currentDate);
                this.swiper.slideTo(index);
            } else {
                const currentDate = moment(date).format('YYYY-MM-DD');
                const index = this.pickerDays.findIndex(e => e.fullDate === currentDate);
                this.swiper.slideTo(index)
            }

        },
        addDaysFromEndSlider(activeIndex) {
            // send request
            this.changeDate({
                from: this.pickerDays[activeIndex].fullDate,
                to: this.pickerDays[activeIndex].fullDate,
            });
            this.getData()
            // end send request

            const lengthSlider = this.pickerDays.length - 1;
            if (activeIndex + 15 > lengthSlider) {
                const startDate = moment(this.pickerDays[lengthSlider].fullDate).add(1, 'days').format('YYYY-MM-DD');
                const endDate = moment(startDate).add(1, 'months').format('YYYY-MM-DD');
                this.pickerDays.push(...this.getRangeDates(startDate, endDate));
                // this.pickerDays.splice(0, 30);
                this.addMounthFromEndSlider(this.swiperMount.activeIndex, false);
            }
            if ((lengthSlider - (lengthSlider - activeIndex)) < 15) {

                const endDate = moment(this.pickerDays[0].fullDate).add(1, 'days').format('YYYY-MM-DD');
                const startDate = moment(endDate).subtract(30, 'days').format('YYYY-MM-DD');

                this.pickerDays.unshift(...this.getRangeDates(startDate, endDate));

                this.addMounthFromEndSlider(this.swiperMount.activeIndex, false);
                this.swiper.slideTo(activeIndex + 31);
            }
        },
        getRangeDates(startDate, endDate, type = 'days') {
            let
                range = moment.range(startDate, endDate),
                array = Array.from(range.by(type));

            return array.map(e => {
                return {
                    day: e.format('DD'),
                    fullDate: e.format('YYYY-MM-DD'),
                    weekday: e.format("dd"),
                    isDayOff: moment(e).day(0).format('YYYY-MM-DD') === e.format('YYYY-MM-DD') || moment(e).day(6).format('YYYY-MM-DD') === e.format('YYYY-MM-DD'),
                    isToday: moment().format('YYYY-MM-DD') === e.format('YYYY-MM-DD')
                };
            });
        },
        getRangeMounth(startDates, endDates) {
            let startDate = moment(startDates);
            let endDate = moment(endDates);
            const timeValues = [];

            while (endDate > startDate || startDate.format('M') === endDate.format('M')) {
                timeValues.push({
                    name: startDate.format('MMMM'),
                    fullDate: startDate.format('YYYY-MM'),
                    yeatMounthDay: startDate.format('YYYY-MM-DD'),
                });
                startDate.add(1, 'month');
            }
            return timeValues;
        },
        addMounthFromEndSlider(activeIndex, isSendRequest = true) {
            if (isSendRequest) {
                // send request
                this.changeDate({
                    from: this.pickerMount[activeIndex].yeatMounthDay,
                    to: this.pickerMount[activeIndex].yeatMounthDay,
                });
                this.getData();
                // end send request
            }
            const lengthSlider = this.pickerMount.length - 1;
            if (activeIndex + 7 > lengthSlider) {
                const startDate = moment(this.pickerMount[lengthSlider].fullDate).add(30, 'days').format('YYYY-MM-DD');
                const endDate = moment(startDate).add(300, 'days').format('YYYY-MM-DD');

                this.pickerMount.push(...this.getRangeMounth(startDate, endDate));
            }
            if ((lengthSlider - (lengthSlider - activeIndex)) < 7) {
                const endDate = moment(this.pickerMount[0].fullDate).subtract(1, 'days').format('YYYY-MM-DD');
                const startDate = moment(endDate).subtract(300, 'days').format('YYYY-MM-DD');

                this.pickerMount.unshift(...this.getRangeMounth(startDate, endDate));
                this.swiperMount.slideTo(activeIndex + 10);
            }
        },
        setActiveMount(mount = null) {
            if (!mount) {
                const currentDate = moment().format('YYYY-MM');
                const index = this.pickerMount.findIndex(e => e.fullDate === currentDate);
                this.swiperMount.slideTo(index)
            } else {
                const currentDate = moment(mount).format('YYYY-MM');
                const index = this.pickerMount.findIndex(e => e.fullDate === currentDate);
                this.swiperMount.slideTo(index)
            }

        },
        getDefaultMounts() {
            const currentDate = moment();
            const startDate = moment().subtract(300, 'd').format('YYYY-MM');
            const endDate = moment(currentDate).add(300, 'days').format('YYYY-MM');
            this.pickerMount = this.getRangeMounth(startDate, endDate);
        },
    }
}
